import { Component, Inject, ViewEncapsulation, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { RatePackageService } from '../../rate-package.service';
import { PacoteDetalhes } from '../../models/pacote-detalhes.model';
import { Util } from '../../../../utils/util';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../shared/EventTypes';
import * as moment from 'moment';
import { Record } from '../../models/record';
import { Pacote } from '../../models/pacote.model';

@Component({
	selector: 'app-others-packages-modal',
	templateUrl: './others-packages-modal.component.html',
	styleUrls: ['./others-packages-modal.component.styl'],
})
export class OthersPackagesModalComponent implements OnInit {

	public detailsRecords: Record[] = [];
	public dataSource: MatTableDataSource<Record>;
	public displayedColumns: Array<string> = ['moviment', 'hired', 'value'];
	public packagesDetails: PacoteDetalhes[];
	public month: number;
	public year: number;

	constructor(
		private ratePackageService: RatePackageService,
		public dialogRef: MatDialogRef<OthersPackagesModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {	}

	ngOnInit(): void {
		this.getDetails();
	}

	onClose(): void {
		this.dialogRef.close();
	}

	getDetails() {
		const date = moment(this.data.package.dtVigencia).format('YYYY-MM-DD');
		this.ratePackageService.getOtherPackageDetails(this.data.package.codPacote, date).subscribe(data => {
			if (data.Sucesso) {
				this.packagesDetails = Util.keysToCamel(data.Retorno) as PacoteDetalhes[];
				this.convertToTable(this.packagesDetails);
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro, tente novamente mais tarde.' });
		});
	}

	convertToTable(details: PacoteDetalhes[]) {
		details.forEach(data => {
			if (data.canais.length > 0) {
				data.canais.forEach(canal => {
					this.detailsRecords.push(new Record(data.nmServico, canal.qtdServico, 0, 0, canal.vlrUnitario, 0));
				});
			}
		});

		this.detailsRecords.push(new Record('Valor Total dos Serviços', '', 0, 0, this.data.package.vlrTotServicos, 0));
		this.detailsRecords.push(new Record('Valor do pacote', '', 0, 0, this.data.package.vlrPacote, 0));
		this.dataSource = new MatTableDataSource(this.detailsRecords);

	}


	getToday = () => moment(this.year + '-' + this.month + '-' + moment(this.year + '-' + this.month, 'YYYY/MM').daysInMonth()).format('YYYY-MM-DD');

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rate-package/others-packages/others-packages-modal/others-packages-modal.component.ts